import { useCallback } from "react";
import { useToast } from "@chakra-ui/react";

/**
 * Hook para busca de CEP via ViaCEP.
 * @param {Function} setFormData - Função para atualizar o estado do formulário.
 * @returns {Object} Objeto contendo as funções checkCEP e handleCEPBlur.
 */
export const useCEP = (onData) => {
  const toast = useToast();

  const checkCEP = useCallback(async (cep) => {
    const cleanCEP = cep.replace(/\D/g, "");
    if (cleanCEP.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cleanCEP}/json/`);
      if (!response.ok) throw new Error("Falha ao buscar dados do CEP");

      const data = await response.json();

      if (data && !data.erro) {
        const newData = {
          cep: cleanCEP,
          endereco: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          estado: data.estado,
          estadoEndereco: data.estado,
          pais: "Brasil",
        };

        if (typeof onData === "function") {
          onData(newData);
        }
      } else if (data.erro) {
        toast({
          title: "CEP não encontrado",
          description: "Verifique o número informado.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching CEP data:", error);
      toast({
        title: "Erro ao buscar CEP",
        description: "Não foi possível conectar ao serviço de busca de CEP.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [onData, toast]);

  const handleCEPBlur = useCallback(async (e) => {
    const cep = e.target.value;
    await checkCEP(cep);
  }, [checkCEP]);

  return { checkCEP, handleCEPBlur };
};
